import { Component, Inject, Optional } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef } from "@angular/material/legacy-dialog";
import { SnackbarService } from '@ctsolution/ct-framework';
import { AddressBookContactController } from 'src/app/core/controllers/address-book-contact.controller';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressBookContactParameter } from 'src/app/core/classes/address-book-contact.parameter';

@Component({
  selector: 'app-address-book-contact-form',
  templateUrl: './address-book-contact-form.component.html',
  styleUrls: ['./address-book-contact-form.component.scss']
})
export class AddressBookContactFormComponent{

  form: FormGroup;
  phonePattern = /^(\+39)?\d{9,10}$/;
  fiscalCodePattern = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;

  constructor(private fb: FormBuilder,
    private snackbar: SnackbarService,
    private addressBookContactController: AddressBookContactController,
    @Optional() private matDialogRef: MatLegacyDialogRef<AddressBookContactFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: AddressBookContactParameter | null) {


      this.form = this.fb.group({
        Name: new FormControl(null, Validators.required),
        Address: new FormControl(null),
        ZipCode: new FormControl(null),
        FiscalCode: new FormControl(null, [Validators.pattern(this.fiscalCodePattern)]),
        City: new FormControl(null),
        Province: new FormControl(null),
        Country: new FormControl(null),
        Email: new FormControl(null, Validators.email),
        Phone: new FormControl(null, [Validators.pattern(this.phonePattern)]),
        CertifiedEmail: new FormControl(null, Validators.email),
        ContactCode: new FormControl(null),
        GroupCode: new FormControl(null)
      });
  }

  ngAfterViewInit() {

    this.setup();

  }

  async setup() {

    if (!this.data) return;

    this.form.patchValue(<any>this.data);

  }


  onSubmit() {

    const form = this.form;

    if (!form || !form.valid) return;

    if(!this.data?.AddressBookOid) return;

    const param: AddressBookContactParameter = AddressBookContactParameter.create()

    param
      .setAddressBookOid(this.data.AddressBookOid)
      .setName(form.value.Name ?? null)
      .setAddress(form.value.Address ?? null)
      .setZipCode(form.value.ZipCode ?? null)
      .setFiscalCode(form.value.FiscalCode ?? null)
      .setCity(form.value.City ?? null)
      .setProvince(form.value.Province ?? null)
      .setCountry(form.value.Country ?? null)
      .setEmail(form.value.Email ?? null)
      .setPhone(form.value.Phone ?? null)
      .setCertifiedEmail(form.value.CertifiedEmail ?? null)
      .setContactCode(form.value.ContactCode ?? null)
      .setGroupCode(form.value.GroupCode ?? null);

    if (this.data?.Oid)
      param.setOid(this.data.Oid)


    this.addressBookContactController
      .save(param)
      .subscribe(() => {

        this.matDialogRef.close();
        this.snackbar.open("Contatto salvato correttamente!", "X");

      });

  }

}
